import Box from "@mui/material/Box";
import LanguageContext from "components/LanguageContext";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";
import t from "utils/locales/translation.json";

const AllNewsSearch = (props) => {
  const { value, setValue, isMobile = false } = props;

  const { language } = useContext(LanguageContext);

  const onChange = (event) => {
    const { value: newValue } = event.target;
    setValue(newValue);
  };

  const inputSearchId = useMemo(() => (isMobile ? "search-news-input-mobile" : "search-news-input"), [isMobile]);

  return (
    <Box className="fr-search-bar" id="search-news" role="search" sx={{ mb: 2.625 }}>
      <label className="fr-label" htmlFor={inputSearchId}>
        {t[language].common.search.label}
      </label>
      <input
        className="fr-input"
        type="search"
        id={inputSearchId}
        name={inputSearchId}
        placeholder={t[language].all_news.placeholder}
        title={t[language].common.search.placeholder}
        value={value}
        onChange={onChange}
      />
      <button type="button" className="fr-btn" title={t[language].common.search.button_title}>
        {t[language].common.search.placeholder}
      </button>
    </Box>
  );
};

AllNewsSearch.propTypes = {
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
};

export default AllNewsSearch;
